import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-16 pb-12 px-6 max-w-4xl mx-auto text-center" data-id="element-92">
      <FadeIn data-id="element-93">
        <h1 className="text-4xl sm:text-5xl md:text-6xl text-taupe leading-tight mb-6" data-id="element-94">
          Recupera tus noches: <br className="hidden sm:block" data-id="element-95" />
          <span className="text-sage" data-id="element-96">El Protocolo de los 15 Minutos</span>
        </h1>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-97">
        <p className="text-lg sm:text-xl text-taupe/80 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-98">
          Logra que tu bebé concilie el sueño de forma autónoma en menos de 15
          minutos, sin dejarlo llorar solo y sin métodos crueles.
        </p>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-99">
        <div className="relative max-w-md mx-auto mb-10" data-id="element-100">
          <div className="absolute inset-0 bg-sage/20 rounded-3xl blur-2xl transform -rotate-3 scale-105" data-id="element-101"></div>
          <img src="https://cdn.magicpatterns.com/uploads/b6Nm7KhV6hYQPGboThVEhf/Protocolo_de_los_15_minutos.png" alt="El Protocolo de los 15 Minutos" className="relative z-10 w-full rounded-2xl shadow-xl" data-id="element-102" />
        </div>
      </FadeIn>

      <FadeIn delay={0.6} data-id="element-103">
        <CTAButton data-id="element-104" />
      </FadeIn>
    </section>;
}